import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import Select from "react-select";
import Switch from "../../components/Switch";
import { toast } from "react-toastify";
import TBLIntegracoes from "../../components/TBLIntegracoes";
import { ListarEstabelecimentosSemPaginacao } from "../../providers/EstabelecimentoProvider";
import {
  AtualizarJobIntegracao,
  CadastrarConfiguracaoIntegracao,
  DeletarConfiguracaoIntegracao,
  EditarConfiguracaoIntegracao,
  ListarIntegracoes,
  ListarSoftwaresIntegracao,
  SetupEstruturaProdutoIntegracao,
  TestarConexaoIntegracao,
} from "../../providers/IntegracaoProvider";

function Integracao() {
  const [integracoes, setIntegracoes] = useState([]);
  const [softwares, setSoftwares] = useState([]);
  const [softwareSelecionado, setSoftwareSelecionado] = useState();
  const [estabelecimentos, setEstabelecimentos] = useState([]);
  const [estabelecimentoSelecionado, setEstabelecimentoSelecionado] = useState();
  const [integracaoSelecionada, setIntegracaoSelecionada] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [isEdition, setEdition] = useState(false);
  const [isViewMode, setViewMode] = useState(false);
  const [form, setForm] = useState({
    ativo: true,
    base_url: "",
    id_interno: "",
    id_clifor: "",
    id_vendedor: "",
    tipo_dav: "",
    username: "",
    password: "",
    grant_type: "",
    client_secret: "",
    client_id: "",
    api_key: "",
    database_name: "",
    database_port: "",
    cron_expression: "",
  });
  const [formError, setFormError] = useState("");

  async function getIntegracoes() {
    try {
      const res = await ListarIntegracoes();
      setIntegracoes(res);
    } catch (error) {
      toast.error("Erro ao listar integrações");
    }
  }

  useEffect(() => {
    getIntegracoes();
  }, []);

  useEffect(() => {
    (async () => {
      const docs = await ListarEstabelecimentosSemPaginacao();
      const mappedOptions = docs
        .filter(
          (e) => !integracoes.find((v) => v.configuracoes.estabelecimento._id === e._id),
        )
        .map((d) => ({
          label: d.nome_fantasia,
          value: d._id,
        }));
      setEstabelecimentos(mappedOptions);
    })();
  }, [integracoes]);

  useEffect(() => {
    (async () => {
      const docs = await ListarSoftwaresIntegracao();
      const mappedOptions = docs.map((d) => ({
        label: d.nome,
        value: d._id,
      }));
      setSoftwares(mappedOptions);
    })();
  }, []);

  const limparForm = () => {
    setForm({});
    setSoftwareSelecionado(null);
    setEstabelecimentoSelecionado(null);
    setIntegracaoSelecionada(null);
    setShowCreateModal(false);
    setShowDeleteModal(false);
    setEdition(false);
    setViewMode(false);
  };

  const receberDadosTabela = (tipo, dados) => {
    if (tipo === "ver_itens") {
      const config = dados.configuracoes;
      setShowCreateModal(true);
      setViewMode(true);
      setIntegracaoSelecionada(dados);
      setForm({
        ...config,
        ...config.credencial,
      });
      setEstabelecimentoSelecionado({
        label: config.estabelecimento?.nome_fantasia,
        value: config.estabelecimento?._id,
      });
      setSoftwareSelecionado({
        label: dados.nome,
        value: dados._id,
      });
    } else if (tipo === "deletar") {
      setIntegracaoSelecionada(dados);
      setShowDeleteModal(true);
    } else {
      return;
    }
  };

  const validaForm = () => {
    let isValid = true;
    let error = "";
    const basicAuth = [!!form.username, !!form.password];
    if (basicAuth.includes(true) && !basicAuth.every((v) => v === true)) {
      isValid = false;
      error = "Preencha o username e o password";
    }
    const oauth = [!!form.grant_type, !!form.client_id, !!form.client_secret];
    if (oauth.includes(true) && !oauth.every((v) => v === true)) {
      isValid = false;
      error = "Preencha o OAUTH completo";
    }
    if (!basicAuth.includes(true) && !oauth.includes(true) && !form.api_key) {
      isValid = false;
      error = "Preencha ao menos um método de autenticação";
    }
    if (!softwareSelecionado?.value) {
      isValid = false;
      error = "Sistema é obrigatório";
    }
    if (!estabelecimentoSelecionado?.value) {
      isValid = false;
      error = "Estabelecimento é obrigatório";
    }
    if (!form.base_url || !form.id_interno) {
      isValid = false;
      error = "Preencha os campos obrigatórios";
    }
    setFormError(error);
    return isValid;
  };

  const getPayload = () => {
    return {
      ativo: form.ativo,
      estabelecimento: estabelecimentoSelecionado.value,
      base_url: form.base_url,
      id_interno: form.id_interno,
      id_clifor: form.id_clifor,
      id_vendedor: form.id_vendedor,
      tipo_dav: form.tipo_dav,
      database_name: form.database_name,
      database_port: form.database_port,
      cron_expression: form.cron_expression,
      credencial: {
        username: form.username,
        password: form.password,
        grant_type: form.grant_type,
        client_secret: form.client_secret,
        client_id: form.client_id,
        api_key: form.api_key,
      },
    };
  };

  const cadastrarConfiguracao = async () => {
    try {
      if (!validaForm()) return;
      const payload = getPayload();
      if (isEdition) {
        await EditarConfiguracaoIntegracao(
          integracaoSelecionada._id,
          integracaoSelecionada.configuracoes._id,
          payload,
        );
        toast.success("Integração editada com sucesso");
      } else {
        await CadastrarConfiguracaoIntegracao(softwareSelecionado.value, payload);
        toast.success("Integração criada com sucesso");
      }
      limparForm();
      await getIntegracoes();
    } catch (error) {
      toast.error("Erro ao cadastrar integração");
    }
  };

  const deletarIntegracao = async () => {
    try {
      await DeletarConfiguracaoIntegracao(
        integracaoSelecionada._id,
        integracaoSelecionada.configuracoes._id,
      );
      toast.success("Integração deletada com sucesso");
      limparForm();
      await getIntegracoes();
    } catch (error) {
      toast.error("Erro ao deletar a integração");
    }
  };

  const testarConexao = async () => {
    try {
      const res = await TestarConexaoIntegracao(
        integracaoSelecionada.configuracoes.estabelecimento._id,
      );
      if (res.connected) {
        toast.success("Conexão funcionando corretamente!!");
      } else {
        toast.error("Erro de conexão com a integração!!");
      }
    } catch (error) {
      toast.error("Erro de conexão com a integração!!");
    }
  };

  const criarEstruturaMercadologica = async () => {
    try {
      const res = await SetupEstruturaProdutoIntegracao(
        integracaoSelecionada.configuracoes.estabelecimento._id,
      );
      if (res.status) {
        toast.success(
          "Criação de estrutura mercadológica iniciada, verifique o status no Telegran",
        );
      } else {
        toast.error("Erro ao criar estrutura mercadológica");
      }
    } catch (error) {
      toast.error("Erro ao criar estrutura mercadológica");
    }
  };

  const ativarDesativarConfiguracao = async () => {
    try {
      if (!validaForm()) return;
      const payload = getPayload();
      await EditarConfiguracaoIntegracao(
        integracaoSelecionada._id,
        integracaoSelecionada.configuracoes._id,
        { ...payload, ativo: !payload.ativo },
      );
      setForm((prev) => ({ ...prev, ativo: !form.ativo }));
      await getIntegracoes();
      toast.success("Integração editada com sucesso");
    } catch (error) {
      toast.error("Erro ao atualizar integração");
    }
  };

  const reiniciarIntegracao = async () => {
    try {
      await AtualizarJobIntegracao(
        integracaoSelecionada.configuracoes.estabelecimento._id,
      );
      toast.success("Integração reiniciada com sucesso!!");
    } catch (error) {
      toast.error("Erro ao reiniciar integração!!");
    }
  };

  return (
    <div style={{ margin: 10, marginLeft: 50, marginRight: 50 }}>
      <br></br>
      <Row>
        <Col md={9}>
          <h3>Integrações Ativas</h3>
        </Col>
        <Col>
          <Button
            onClick={() => {
              setShowCreateModal(true);
            }}
          >
            Nova Integração
          </Button>
        </Col>
      </Row>
      <br></br>
      <TBLIntegracoes data={integracoes} numRows={13} dataCallback={receberDadosTabela} />
      <br></br>
      <Modal size="xl" show={showCreateModal} onHide={() => limparForm()}>
        <Modal.Header closeButton className="modalHeader">
          {isViewMode ? (
            <Modal.Title>Integração</Modal.Title>
          ) : (
            <Modal.Title>
              {isEdition ? "Editar Integração" : "Cadastrar Integração"}
            </Modal.Title>
          )}
        </Modal.Header>
        <Modal.Body>
          {formError ? (
            <div>
              <p style={{ color: "red" }}>{formError}</p>
            </div>
          ) : null}
          <Form>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>
                    Integração {form.ativo ? "ativada" : "desativada"}:
                  </Form.Label>
                  <Switch
                    checked={form.ativo}
                    onChange={(e) => {
                      ativarDesativarConfiguracao();
                    }}
                  />
                </Form.Group>
              </Col>
              <Col style={{ flexGrow: 0 }}>
                {isViewMode && (
                  <Button
                    variant="primary"
                    onClick={() => {
                      setEdition((prev) => !prev);
                      setViewMode((prev) => !prev);
                    }}
                  >
                    {"Editar"}
                  </Button>
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>Sistema *</Form.Label>
                  <Select
                    isDisabled={isViewMode || !softwares.length}
                    value={softwareSelecionado}
                    isClearable
                    isSearchable
                    onChange={(opt) => {
                      setSoftwareSelecionado(opt);
                    }}
                    options={softwares}
                    placeholder="Sistema"
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>Estabelecimento *</Form.Label>
                  <Select
                    isDisabled={isViewMode || !estabelecimentos.length}
                    value={estabelecimentoSelecionado}
                    isClearable
                    isSearchable
                    onChange={(opt) => {
                      setEstabelecimentoSelecionado(opt);
                    }}
                    options={estabelecimentos}
                    placeholder="Estabelecimento"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>Url da Api ou IP do Banco de dados *</Form.Label>
                  <Form.Control
                    disabled={isViewMode}
                    value={form.base_url}
                    placeholder="Url da Api ou IP do Banco de dados"
                    onChange={(e) => {
                      const value = e.target.value;
                      setForm((prev) => ({ ...prev, base_url: value }));
                    }}
                  />
                  <Form.Text>Ex: https://www.test.com ou 192.168.0.1</Form.Text>
                </Form.Group>
              </Col>
            </Row>
            <h5>Banco de Dados</h5>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>Nome do banco de dados</Form.Label>
                  <Form.Control
                    disabled={isViewMode}
                    value={form.database_name}
                    placeholder="Nome do banco de dados"
                    onChange={(e) => {
                      const value = e.target.value;
                      setForm((prev) => ({ ...prev, database_name: value }));
                    }}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>Porta do banco de dados</Form.Label>
                  <Form.Control
                    disabled={isViewMode}
                    value={form.database_port}
                    placeholder="Porta do banco de dados"
                    onChange={(e) => {
                      const value = e.target.value;
                      setForm((prev) => ({ ...prev, database_port: value }));
                    }}
                  />
                  <Form.Text>Ex: 3306</Form.Text>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>Id Interno *</Form.Label>
                  <Form.Control
                    disabled={isViewMode}
                    value={form.id_interno}
                    placeholder="Id Interno"
                    onChange={(e) => {
                      const value = e.target.value;
                      setForm((prev) => ({ ...prev, id_interno: value }));
                    }}
                  />
                  <Form.Text>Id do estabelecimento no sistema de integração</Form.Text>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>Id do Cliente</Form.Label>
                  <Form.Control
                    disabled={isViewMode}
                    value={form.id_clifor}
                    placeholder="Id do Cliente"
                    onChange={(e) => {
                      const value = e.target.value;
                      setForm((prev) => ({ ...prev, id_clifor: value }));
                    }}
                  />
                  <Form.Text>
                    Id do cliente padrão usado para gerar o orçamento(DAV) no sistema de
                    integração
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>Id do Vendedor</Form.Label>
                  <Form.Control
                    disabled={isViewMode}
                    value={form.id_vendedor}
                    placeholder="Id do Vendedor"
                    onChange={(e) => {
                      const value = e.target.value;
                      setForm((prev) => ({ ...prev, id_vendedor: value }));
                    }}
                  />
                  <Form.Text>
                    Id do vendedor usado para gerar o orçamento(DAV) no sistema de
                    integração
                  </Form.Text>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>Tipo de DAV</Form.Label>
                  <Form.Control
                    disabled={isViewMode}
                    value={form.tipo_dav}
                    placeholder="Tipo de DAV"
                    onChange={(e) => {
                      const value = e.target.value;
                      setForm((prev) => ({ ...prev, tipo_dav: value }));
                    }}
                  />
                  <Form.Text>
                    Tipo de DAV usado para gerar o orçamento(DAV) no sistema de integração
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>
            <h5>Credênciais</h5>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>Username</Form.Label>
                  <Form.Control
                    disabled={isViewMode}
                    value={form.username}
                    placeholder="Username"
                    onChange={(e) => {
                      const value = e.target.value;
                      setForm((prev) => ({ ...prev, username: value }));
                    }}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    disabled={isViewMode}
                    value={form.password}
                    placeholder="Password"
                    onChange={(e) => {
                      const value = e.target.value;
                      setForm((prev) => ({ ...prev, password: value }));
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>Grant Type</Form.Label>
                  <Form.Control
                    disabled={isViewMode}
                    value={form.grant_type}
                    placeholder="Grant Type"
                    onChange={(e) => {
                      const value = e.target.value;
                      setForm((prev) => ({ ...prev, grant_type: value }));
                    }}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>Client Id</Form.Label>
                  <Form.Control
                    disabled={isViewMode}
                    value={form.client_id}
                    placeholder="Client Id"
                    onChange={(e) => {
                      const value = e.target.value;
                      setForm((prev) => ({ ...prev, client_id: value }));
                    }}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>Client Secret</Form.Label>
                  <Form.Control
                    disabled={isViewMode}
                    value={form.client_secret}
                    placeholder="Client Secret"
                    onChange={(e) => {
                      const value = e.target.value;
                      setForm((prev) => ({ ...prev, client_secret: value }));
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>API Key</Form.Label>
                  <Form.Control
                    disabled={isViewMode}
                    value={form.api_key}
                    placeholder="API Key"
                    onChange={(e) => {
                      const value = e.target.value;
                      setForm((prev) => ({ ...prev, api_key: value }));
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
            <h5>Frequência</h5>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>Expressão Cron</Form.Label>
                  <Form.Control
                    disabled={isViewMode}
                    value={form.cron_expression}
                    placeholder="Expressão Cron"
                    onChange={(e) => {
                      const value = e.target.value;
                      setForm((prev) => ({ ...prev, cron_expression: value }));
                    }}
                  />
                  <Form.Text>
                    Criará o job que irá rodar com base no cron informado, se não passado,
                    a integração irá rodar a cada 4 horas
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>
          </Form>
          <hr></hr>
          <Row>
            {isViewMode && (
              <>
                <Col md="3">
                  <Form.Group>
                    <Button
                      variant="primary"
                      onClick={() => criarEstruturaMercadologica()}
                    >
                      Criar Estrutura Mercadológica
                    </Button>
                    <Form.Text>
                      Cria corredores, categorias e popula os produtos do estabelecimento
                    </Form.Text>
                  </Form.Group>
                </Col>
                <Col md="2">
                  <Button variant="warning" onClick={() => testarConexao()}>
                    Testar Conexão
                  </Button>
                </Col>
                <Col md="3">
                  <Button variant="danger" onClick={() => reiniciarIntegracao()}>
                    Reiniciar integração
                  </Button>
                </Col>
              </>
            )}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              limparForm();
            }}
          >
            Fechar
          </Button>
          {isEdition && (
            <Button variant="primary" onClick={() => cadastrarConfiguracao()}>
              {"Editar"}
            </Button>
          )}
          {!isViewMode && !isEdition && (
            <Button variant="primary" onClick={() => cadastrarConfiguracao()}>
              {"Cadastrar"}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
      <Modal size="sm" show={showDeleteModal} onHide={() => limparForm()}>
        <Modal.Header closeButton>
          <Modal.Title>Alerta</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Deseja realmente excluir a integração?</p>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              limparForm();
            }}
          >
            Não
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              deletarIntegracao();
            }}
          >
            Sim
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Integracao;
